export default "__VITE_ASSET__264b0168__"